import { NetlifyLogsButton } from '~/components/ui/NetlifyLogsButton';
import type { ErrorDisplayProps } from '~/lib/types/netlify';
import { Tooltip } from '~/components/ui/Tooltip';
import { useTranslation } from '~/lib/hooks/useTranslation';

export const ErrorDisplay = ({
  error,
  adminUrl,
  onFixWithDualite,
  deployedId,
  accessToken,
  deployStatus,
  hasExistingDeployment = false,
}: ErrorDisplayProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <div
          className={`rounded-md border border-white/20 bg-white/5 p-4 ${!adminUrl || hasExistingDeployment ? 'w-full' : 'flex-1'}`}
        >
          <div className="flex items-start gap-3">
            <div className="i-ph:warning-circle-fill w-5 h-5 text-white flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="text-white text-sm font-medium mb-1">{t('deployment.failed')}</p>
              <p className="text-[#e7e7e7]/80 text-sm">
                {error?.includes('rate limit') ? (
                  <>
                    {t('deployment.rateLimitReached')}
                    <br />
                    <span className="text-xs opacity-80 mt-1 block">
                      {t('deployment.rateLimitNote')}
                    </span>
                  </>
                ) : (
                  error
                )}
              </p>
            </div>
          </div>
        </div>
        {adminUrl && !hasExistingDeployment && (
          <Tooltip content="Inspect Deployment" className="h-[60px] w-[60px] flex items-center justify-center">
            <button
              onClick={() => window.open(adminUrl ?? '', '_blank')}
              className="h-full w-full rounded-md border border-white/20 bg-transparent 
          hover:bg-white/5 transition-all duration-200
          text-[#e7e7e7]/70 hover:text-white flex items-center justify-center"
            >
              <div
                className="i-ph:gear w-5 h-5 flex-shrink-0"
              />
            </button>
          </Tooltip>
        )}
      </div>

      {/* Add NetlifyLogsButton for error state */}
      {deployedId && (
        <div className="mt-2">
          <NetlifyLogsButton
            deployedId={deployedId}
            accessToken={accessToken}
            deployStatus={deployStatus}
            autoExpand={deployStatus === 'error'}
            adminUrl={adminUrl}
          />
        </div>
      )}
      {/* Fix with Dualite button */}
      <button
        id="fix-with-dualite-button"
        onClick={onFixWithDualite}
        className="w-full px-4 py-2.5 bg-white 
          rounded-md text-black text-sm font-semibold hover:bg-[#e6e6e6] transition-all
          flex items-center justify-center gap-2 shadow-sm"
      >
        <div className="i-ph:wrench-fill w-4 h-4" />
        <span>Fix with Dualite</span>
      </button>
    </div>
  );
};
